import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import "./Sidebar.css";

const Sidebar = ({ onToggle }) => {
  const [open, setOpen] = useState(false);

  const toggleSidebar = () => {
    setOpen(!open);
    onToggle(!open); // Notify Layout to shift content
  };

  return (
    <div>
      <div className={`sidebar ${open ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleSidebar}>
          <CloseIcon />
        </button>
        {/* Sidebar content here */}
      </div>
      {!open && (
        <button className="menu-btn" onClick={toggleSidebar}>
          <MenuIcon />
        </button>
      )}
    </div>
  );
};

export default Sidebar;

